import { useMemo } from "react";
import { useFetchApi } from "../../hooks/useFetchApi";
import { BillingDetails } from "shared";

export const useBilling = () => {
  const { data: billingDetails } = useMemo(
    () => useFetchApi<BillingDetails>("billing", 2),
    []
  );

  return billingDetails;
};
